import React from 'react';
import { Result, Button } from 'antd';
import { WifiOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

interface NetworkErrorProps {
  onRetry: () => void;
  message?: string;
}

const NetworkError: React.FC<NetworkErrorProps> = ({ 
  onRetry, 
  message 
}) => {
  const { t } = useTranslation();
  
  return (
    <Result
      icon={<WifiOutlined style={{ color: '#ff4d4f' }} />}
      title={t('common.networkError')}
      subTitle={message || t('error.networkConnectionError')}
      extra={
        <Button type="primary" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      }
    />
  );
};

export default NetworkError;